import React, { useEffect, useState } from 'react';
import '../styles/pages/VisionMissionPage.css';
import { getVisionMissionContent } from '../services/api';

const fallbackContent = {
  hero_title: 'Vision, Mission & Core Values',
  hero_description:
    'The vision and mission presented here are as stipulated in the COSTECH rolling strategic plan of 2021/22 - 2025/2026. They guide the Commission’s efforts to coordinate and promote science, technology and innovation across the nation.',
  vision: 'A nation driven by Science, Technology and Innovation.',
  mission:
    'Ensure utilization of knowledge-based products through coordination and promotion of science, technology and innovation for rapid social-economic development.',
  quality_policy_paragraphs: [
    'COSTECH is committed to coordinate, promote and facilitate science, technology and innovation in the country by meeting legal and customer requirements and even exceeding customer expectations.',
    'COSTECH provides resources and continually improve its processes to meet requirements of ISO 9001:2015 by ensuring staff are capable of delivering quality products and services timely and consistently to ensure that country is driven by science, technology and innovation.',
  ],
  values_title: 'Our Core Values',
  values_intro: 'In undertaking our roles and functions, we uphold the following core values:',
  core_values: [
    {
      title: 'Integrity',
      description:
        'We demonstrate ethics, responsibility and honesty in performing our duties at all times.',
    },
    {
      title: 'Excellence',
      description: 'We strive for best-in-class delivery of service.',
    },
    {
      title: 'Customer Focus',
      description: "We put our customers' and stakeholders’ needs first.",
    },
    {
      title: 'Professionalism',
      description:
        'We comply with laws, promote best practices and use our knowledge diligently in all work.',
    },
    {
      title: 'Accountability',
      description:
        'We promote openness and transparency to ensure timely delivery of products and services.',
    },
    {
      title: 'Teamwork',
      description:
        'We recognise and value the contribution of individuals and teams in realising our vision.',
    },
  ],
};

const normalizeContent = (content) => ({
  ...fallbackContent,
  ...(content || {}),
  quality_policy_paragraphs:
    Array.isArray(content?.quality_policy_paragraphs) && content.quality_policy_paragraphs.length > 0
      ? content.quality_policy_paragraphs
      : fallbackContent.quality_policy_paragraphs,
  core_values:
    Array.isArray(content?.core_values) && content.core_values.length > 0
      ? content.core_values
      : fallbackContent.core_values,
});

const VisionMissionPage = () => {
  const [content, setContent] = useState(fallbackContent);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const apiContent = await getVisionMissionContent();
        setContent(normalizeContent(apiContent));
      } catch (error) {
        console.error('VisionMissionPage: Error fetching content:', error);
        setContent(fallbackContent);
      }
    };

    fetchContent();
  }, []);

  return (
    <section className="vision-page">
      <div className="vision-hero">
        <div className="vision-hero-overlay" />
        <div className="vision-hero-content">
          <h1>{content.hero_title}</h1>
          <p>{content.hero_description}</p>
        </div>
      </div>

      <div className="vision-content">
        <div className="vision-card">
          <span className="vision-card-tag">Vision</span>
          <h2>{content.vision}</h2>
        </div>

        <div className="vision-card">
          <span className="vision-card-tag vision-card-tag--mission">Mission</span>
          <h2>{content.mission}</h2>
        </div>
      </div>

      <section className="quality-policy-section">
          <div className="quality-policy-header">
            <span className="quality-policy-tag">Quality Policy</span>
          </div>
          <div className="quality-policy-content">
            {content.quality_policy_paragraphs.map((paragraph, index) => (
              <p key={index} className="quality-policy-text">
                <strong>{paragraph}</strong>
              </p>
            ))}
          </div>
      </section>

      <section className="values-section">
        <div className="values-header">
          <h2>{content.values_title}</h2>
          <p>{content.values_intro}</p>
        </div>

        <div className="values-timeline">
          {content.core_values.map((value, index) => (
            <article key={`${value.title}-${index}`} className="values-timeline-item">
              <div className="values-marker">
                <span>{index + 1}</span>
              </div>
              <div className="values-card-surface">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
};

export default VisionMissionPage;

